<template>
  <div class="big doctorInvitationWrite">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">推荐人邀请码未填写监测记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div
        class="container"
        style="padding: 10px 20px 20px 20px;"
      >

        <div class="search-box">

          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="prescriptionForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="医生"
              ></el-input>
            </div>
          </div>

          <!-- 医生手机号 -->
          <div class="item">
            <span>医生手机号</span>
            <div class="item-content">
              <el-input
                v-model="prescriptionForm.doctor_phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="医生手机号"
              ></el-input>
            </div>
          </div>

          <!-- 注册时间 -->
          <div class="item">
            <span style="width: 70px;">注册时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="prescriptionForm.create_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 是否认证 -->
          <div class="item">
            <span>是否认证</span>
            <div class="item-content">
              <el-radio-group
                v-model="prescriptionForm.auth_status"
                size="small"
                @change="getList"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left:20px"
              @click="getList"
            >查询</el-button>
            <el-button
              size="small"
              @click="restBtn"
            >重置</el-button>
          </div>

        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            v-loading="tableLoading"
            :data="prescriptionData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :align="item.align"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div
                  v-else-if="item.prop == 'doctor_name'"
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >
                  {{ scope.row.doctor_name}}
                </div>
                <div v-else-if="item.prop == 'sex'">
                  {{ scope.row[item.prop] | sexText }}
                </div>
                <div v-else>{{ !scope.row[item.prop] ? '' : scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled=" module_id_array[0] ? !module_id_array.includes('829') : false"
                  @click="fillIn(scope.row)"
                >补填邀请码</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum>0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>

    <!-- 补填邀请码 -->
    <el-dialog
      title="补填邀请码"
      :visible.sync="isInviteCode"
      width="520px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="beforeClose"
    >
      <div class="diaCodebox">
        <div class="info-box">
          <p>
            医生： <span>{{ doctor_info.doctor_name }}</span>
            <span>{{ doctor_info.sex | sexText }}</span>
            <span>{{ doctor_info.phone }}</span>
          </p>
        </div>

        <div class="align-center">
          <span class="searchtitle">邀请码</span>

          <el-input
            v-model="recommender_code"
            size="medium"
            style="margin-left: 10px; width: 200px"
            placeholder="请输入"
          ></el-input>
          <el-button
            type="primary"
            size="small"
            style="margin-left:20px"
            :loading="isSearchCode"
            @click="searchCode"
            :disabled=" module_id_array[0] ? !module_id_array.includes('828') : false "
          >查询</el-button>
        </div>
        <div
          v-if="!hintType"
          style="padding-right: 200px;color:#ff9000"
        >
          未查到对应邀请人，请重新输入。
        </div>

        <div
          v-if="hintType === 1"
          class="invite-info"
        >
          <p>邀请人：<span>{{ inviteInfo.recommender_name }}</span>
            <span>{{ inviteInfo.phone }}</span>
          </p>
          <p>
            请确认是否绑定该邀请人？
          </p>
        </div>

      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="cancel"
          size="small"
        >取 消</el-button>
        <el-button
          type="primary"
          :loading="isBinding"
          size="small"
          @click="confirm"
          :disabled=" module_id_array[0] ? !module_id_array.includes('829') : false "
        >确 定 绑 定</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import systemWarning from '@/api/systemWarning.js';
import Pagination from '@/components/Pagination/index';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  components: {
    Pagination,
    DocMsg
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      prescriptionForm: {
        doctor_name: '',
        doctor_phone: '',
        create_time: [],
        auth_status: 0
      },
      tableHeader: [
        {
          label: '注册时间',
          prop: 'create_time',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: '120',
          align: 'center',
          fixed: false
        },
        {
          label: '性别',
          prop: 'sex',
          width: '110',
          align: 'center',
          fixed: false
        },
        {
          label: '医生手机号',
          prop: 'phone',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '医院名称',
          prop: 'hospital',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '科室',
          prop: 'department_name',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      prescriptionData: [],
      isInviteCode: false,
      doctor_info: {},
      isBinding: false,
      isSearchCode: false,
      recommender_code: '',
      inviteInfo: {},
      hintType: 3,
      doc_msg: false,
      doctorId: ''
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    sexText(val) {
      switch (val) {
        case 1:
          return '男';
        case 2:
          return '女';
        default:
          return '未知';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    // this.initCompletionTime();
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },

    initCompletionTime() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format('YYYY-MM-DD');
      start = dayjs(start).format('YYYY-MM-DD');
      this.prescriptionForm.create_time = [start, end];
    },
    getList() {
      let params = Object.assign(this.pagination, this.prescriptionForm);
      params = _.omit(params, ['create_time']);
      let create_time = this.prescriptionForm.create_time;
      params['create_time_start'] = create_time ? create_time[0] : '';
      params['create_time_end'] = create_time ? create_time[1] : '';
      this.tableLoading = true;
      systemWarning.doctorInvitationWrite(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.prescriptionData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    fillIn(row) {
      this.doctor_info = row;
      this.isInviteCode = true;
    },
    // 退款弹窗关闭
    beforeClose(done) {
      this.cancel();
      done();
    },
    // 查询邀请码
    searchCode: _.throttle(
      function () {
        if (this.recommender_code == '') {
          this.$message.warning('请输入邀请码');
          return;
        }
        this.isSearchCode = true;
        let params = {
          recommender_code: this.recommender_code
        };
        systemWarning
          .recommenderInfo(params)
          .then((res) => {
            let { code, data } = res;
            if (!data.info) {
              this.$message.warning('未查到对应邀请人');
              this.hintType = 0;
            } else {
              this.$message.success('查询成功');
              this.hintType = 1;
              this.inviteInfo = data.info;
            }
            this.isSearchCode = false;
          })
          .catch((err) => {
            this.isSearchCode = false;
          });
      },
      2000,
      { trailing: false }
    ),
    cancel() {
      this.isInviteCode = false;
      this.hintType = 3;
      this.recommender_code = '';
    },
    confirm() {
      if (this.hintType !== 1) {
        this.$message.warning('请填写有效邀请码');
        return;
      }
      let params = {
        recommender_code: this.recommender_code,
        doctor_id: this.doctor_info.doctor_id
      };
      systemWarning.doctorBindingRecommender(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success('绑定成功');
          this.getList();
        }
      });
      this.cancel();
    },
    restBtn() {
      for (let key in this.prescriptionForm) {
        if (key == 'create_time') {
          this.prescriptionForm[key] = [];
        } else if (key == 'auth_status') {
          this.prescriptionForm[key] = 0;
        } else {
          this.prescriptionForm[key] = '';
        }
      }
      // this.initCompletionTime();
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.doctorInvitationWrite {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
.diaCodebox {
  .info-box {
    height: 60px;
    padding: 10px 20px;
    margin: 0;
    border: 0;
    p {
      margin: 0;
      padding: 0;
      font-size: 16px;
      display: flex;
      align-items: center;
      line-height: 40px;
    }
    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }
  .align-center {
    margin: 10px 0 10px;
    .searchtitle {
      width: 60px;
      text-align: right;
    }
  }
  .invite-info {
    padding-left: 70px;
    color: #ff9000;
    p {
      margin: 0;
      padding: 0;
      font-size: 15px;
      text-align: left;
      padding-bottom: 10px;
    }
  }
}
</style>